import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ViewIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ViewIcon: React.FC<ViewIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-view">
    <path
      d="M6 25 C10 15 18 10 25 10 C32 10 40 15 44 25 C40 35 32 40 25 40 C18 40 10 35 6 25
M25 18 A7 7 0 1 1 24.999 18"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default ViewIcon;
